import * as types from './mutation-types';
import api from '@/api';
import { timeFormat } from '@/utils/date';
import config from '@/config';
/**
 * 添加上报日志
 */
export const addErrorLog = function({ commit, rootState }, payload) {
	const {
		user: { userInfo }
	} = rootState;

	let data = {
		date: timeFormat(+new Date(), 'yyyy-MM-dd hh:mm:ss'),
		url: window.location.href,
		username: userInfo.username,
		user_id: userInfo.uid,
		role: userInfo.role,
		role_id: userInfo.roleId
	};
	data = Object.assign(data, payload);
	/**
	 * 切勿删除！！！！
	 * 由于 error 统一被 Vue.config.errorHandler 函数拦截。无法在控制台获取错误信息(异步除外)
	 * 只能使用 console.error 函数在控制台上打印错误
	 */
	if (!data.status) {
		console.error(data.error);
	}

	commit(types.SAVE_ERROR_LOG, data);
	const { host, project, store } = config.logger.error_log;
	// 上报异常
	let tracker = new window.Tracker(host, project, store);
	if (tracker) {
		tracker.track(data);
	}
};
/**
 * 获取下载任务
 */
export const getDownloads = ({ commit, state }, payload) => {
	return new Promise((resolve, reject) => {
		api.user
			.getDownloads(payload)
			.then(res => {
				commit(types.ADD_DOWNLOAD, res.data);
				let downloads = state.downloads;
				let isFinished = true;
				let timeout = '';
				for (let i in downloads) {
					if (downloads[i].progress < 100) {
						isFinished = false;
					}
				}
				commit(types.CHANGE_DOWNLOAD_STATE, isFinished);
				if (isFinished) {
					// console.log('state: ', res.data);
					clearInterval(timeout);
					location.href = res.data[0].file_url;
					commit(types.REMOVE_DOWNLOADS);
				} else {
					timeout = setTimeout(() => {
						getDownloads({ commit, state }, payload);
					}, 1000);
				}
				resolve(res);
			})
			.catch(e => {
				reject(e);
			});
	});
};
